import { Paginated } from '../../../shared/types/IPaginationResponse'
import apiClient from '../../../shared/config/axios'
import { Gewerk, GewerkFilters } from '@myapp/contract'

export const gewerkApi = {
  search: (params: GewerkFilters & { page: number }) =>
    apiClient.get<Paginated<Gewerk>>('/gewerk', { params }),

  getById: (id: number) =>
    apiClient.get<Gewerk>(`/gewerk/${id}`),
}
